export function urlsAreEqual(url1: string, url2: string) {
  if (url1 === undefined || url1 === null || url2 === undefined || url2 === null) {
    return false;
  }

  if (!url1.startsWith('/')) {
    url1 = '/' + url1;
  }
  if (!url2.startsWith('/')) {
    url2 = '/' + url2;
  }

  if (!url1.endsWith('/')) {
    url1 = url1 + '/';
  }
  if (!url2.endsWith('/')) {
    url2 = url2 + '/';
  }

  return url1.toLowerCase() === url2.toLowerCase();
}
